import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/not_found.png'


const _hoisted_1 = { class: "__report-lesson" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "__report-lesson__container"
}
const _hoisted_4 = { class: "font-semibold text-lg text-neutral-600 mb-4" }
const _hoisted_5 = { class: "mb-10" }
const _hoisted_6 = { class: "shadow-sm sm:rounded-2xl overflow-hidden" }
const _hoisted_7 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_8 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_9 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_10 = { class: "bg-neutral-100 h-16" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}, " Tuần ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}, " THỜI GIAN ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}, " Buổi học ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}, " Lĩnh vực ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}, " Mục tiêu ", -1)
const _hoisted_16 = {
  key: 0,
  scope: "col",
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}, " PH ĐÃ XEM ", -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "px-3 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 0,
  class: "px-3 py-4 whitespace-nowrap text-neutral-700"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "text-xs font-medium leading-none text-white" }
const _hoisted_33 = { class: "ml-4 font-semibold text-blue-600" }
const _hoisted_34 = {
  style: {"width":"100px"},
  class: "px-3 py-4 capitalize whitespace-nowrap"
}
const _hoisted_35 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center flex-col"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  height: "250",
  width: "250"
}, null, -1)
const _hoisted_37 = {
  class: "text-neutral-500 text-lg text-center",
  style: {"max-width":"700px"}
}
const _hoisted_38 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaInfinityLoading = _resolveComponent("DaInfinityLoading")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.weeklyReports && _ctx.weeklyReports.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeklyReports, (list, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(list.title), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("table", _hoisted_9, [
                              _createElementVNode("thead", _hoisted_10, [
                                _createElementVNode("tr", null, [
                                  _hoisted_11,
                                  _hoisted_12,
                                  _hoisted_13,
                                  _hoisted_14,
                                  _hoisted_15,
                                  (_ctx.isAdmin)
                                    ? (_openBlock(), _createElementBlock("th", _hoisted_16, " Nộp bởi "))
                                    : _createCommentVNode("", true),
                                  _hoisted_17
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.data, (item, index) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    onClick: ($event: any) => (
													item?.completed &&
														_ctx.$router.push({
															path: `/report/week/${item.student.id}`,
															query: {
																..._ctx.$route.query,
																week_start:
																	item?.week_start,
																student_id:
																	item
																		?.student
																		?.id,
															},
														})
												),
                                    key: item.id,
                                    class: _normalizeClass([
													index % 2 === 0
														? 'bg-white'
														: 'bg-neutral-50'
												, "text-neutral-700 cursor-pointer hover:bg-orange-50"])
                                  }, [
                                    _createElementVNode("td", _hoisted_19, [
                                      (item.week_start)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$filters.toWeek(
																item.week_start,
																true
															)), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_21, [
                                      (item.week_start)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.$filters.formatDate2(
																item.week_start
															)) + " - " + _toDisplayString(_ctx.$filters
																.DAYJS(
																	item.week_start
																)
																.add(7, 'day')
																.format(
																	'DD/MM/YYYY'
																)), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_23, [
                                      (
															item?.lesson_count
														)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(item?.lesson_count), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_25, [
                                      (item?.skill_count)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(item?.skill_count), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", _hoisted_27, [
                                      (item?.skill_count)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(item?.goal_count), 1))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.isAdmin)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_29, [
                                          (
															item?.submitted_by_staff
														)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                onClick: _withModifiers(($event: any) => (
															_ctx.$router.push(
																`/record/employee/${item?.submitted_by_staff?.id}`
															)
														), ["stop"]),
                                                class: "flex items-center cursor-pointer"
                                              }, [
                                                (
																item
																	?.submitted_by_staff
																	?.profile_photo
																	?.w200
															)
                                                  ? (_openBlock(), _createElementBlock("img", {
                                                      key: 0,
                                                      class: "shadow-sm inline-block h-6 w-6 rounded-full",
                                                      src: 
																item
																	?.submitted_by_staff
																	?.profile_photo
																	?.w200
															,
                                                      alt: ""
                                                    }, null, 8, _hoisted_31))
                                                  : (_openBlock(), _createElementBlock("span", {
                                                      key: 1,
                                                      class: "inline-flex items-center justify-center h-6 w-6 rounded-full",
                                                      style: _normalizeStyle({
																background:
																	item
																		?.submitted_by_staff
																		?.profile_photo
																		?.default
																		?.color,
															})
                                                    }, [
                                                      _createElementVNode("span", _hoisted_32, _toDisplayString(item
																		?.submitted_by_staff
																		?.profile_photo
																		?.default
																		?.initial), 1)
                                                    ], 4)),
                                                _createElementVNode("div", _hoisted_33, _toDisplayString(item
																	?.submitted_by_staff
																	?.name), 1)
                                              ], 8, _hoisted_30))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_34, _toDisplayString(item.numbers_of_parent_read) + "/ " + _toDisplayString(item.total_parent_count), 1)
                                    ])
                                  ], 10, _hoisted_18))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                (_ctx.isInfinityLoading)
                  ? (_openBlock(), _createBlock(_component_DaInfinityLoading, {
                      key: 0,
                      onInfiniteLoad: _ctx.getWeeklyReports,
                      loaded: _ctx.stopLoad,
                      "is-loading": _ctx.isLoading
                    }, null, 8, ["onInfiniteLoad", "loaded", "is-loading"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, " Báo cáo tuần được tạo tự động dựa vào các báo cáo buổi học cá nhân trong tuần. Bạn hãy bắt đầu báo cáo các buổi học can thiệp trên app " + _toDisplayString(_ctx.$filters.terminology('teacher')) + ", để có thể làm báo cáo tuần cho học sinh dựa vào những báo cáo đó nhé. ", 1)
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _createVNode(_component_Loading)
        ]))
  ]))
}